import { useCallback, useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Heading, Text } from 'react-aria-components';
import { VerificationForm } from 'src/components/auth';
import BackButton from 'src/components/BackButton';
import Button from 'src/components/ui/Button';
import AuthIcon from 'src/assets/icons/authenticator.svg';
import CheckIcon from 'src/assets/icons/shield-check.svg';

const TwoFactorAuthPage = () => {
  const [success, setSuccess] = useState(false);
  const setupCode = 'SHA231SQK24K';

  if (success) return <SuccessScreen />;

  return (
    <>
      <BackButton to="/profile" hash="security" className="mx-6 my-4" />
      <div className="bg-surface-alt rounded-3xl shadow-3 px-4 sm:px-6 pt-10 pb-6">
        <div className="flex flex-col justify-center items-center mb-12">
          <AuthIcon className="w-14 h-14" />
          <Heading
            level={5}
            className="text-center text-surface-alt-90 text-3xl font-bold my-6"
          >
            Configure your Authenticator
          </Heading>
          <div className="bg-white border border-surface-ghost rounded-3xl overflow-hidden">
            <QRCodeSVG size={220} value={setupCode} includeMargin />
          </div>
        </div>
        <Text elementType="p" className="mb-2">
          Style bbq wing pizza lasagna. Stuffed extra mushrooms tomato hand.
          Fresh ham ranch parmesan burnt pesto dolor broccoli.
        </Text>
        <span className="bg-surface-alt-ghost text-surface-alt-ghost-90 text-base font-medium p-2 rounded-lg">
          {setupCode}
        </span>

        <VerificationForm
          className="max-w-[25rem] mt-12 mb-2"
          onCompleted={() => setSuccess(true)}
        />
      </div>
    </>
  );
};

const SuccessScreen = () => {
  const navigate = useNavigate();

  const onDone = useCallback(
    () => navigate({ to: '/dashboard', replace: true }),
    [navigate]
  );

  useEffect(() => {
    const timeout = setTimeout(onDone, 5000);

    return () => clearTimeout(timeout);
  }, [onDone]);

  return (
    <div className="bg-surface-alt rounded-3xl shadow-3 px-4 sm:px-6 pt-10 pb-6 text-center mt-12">
      <CheckIcon className="inline-block w-14 h-14" />
      <Heading
        level={5}
        className="text-center text-surface-alt-90 text-3xl font-bold mt-6 mb-12"
      >
        Successfully configured a two-factor authentication
      </Heading>
      <Text elementType="p" className="text-surface-alt-90 mb-2">
        Style bbq wing pizza lasagna. Stuffed extra mushrooms tomato hand. Fresh
        ham ranch parmesan burnt pesto dolor broccoli.
      </Text>
      <Button
        onPress={onDone}
        className="min-w-32 justify-center my-8"
        variant="success"
      >
        Done
      </Button>
    </div>
  );
};

export const Route = createFileRoute('/_authenticated/_layout-basic/2fa')({
  component: TwoFactorAuthPage,
});
